import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const APIIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M7 4C3.14 4 0 7.14 0 11C0 14.86 3.14 18 7 18C9.72 18 12.17 16.42 13.32 14H16V18H22V14H24V8H13.32C12.17 5.58 9.72 4 7 4ZM22 12H20V16H18V12H11.94L11.71 12.67C11.01 14.66 9.11 16 7 16C4.24 16 2 13.76 2 11C2 8.24 4.24 6 7 6C9.11 6 11.01 7.34 11.71 9.33L11.94 10H22V12ZM7 8C5.35 8 4 9.35 4 11C4 12.65 5.35 14 7 14C8.65 14 10 12.65 10 11C10 9.35 8.65 8 7 8ZM7 12C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10C7.55 10 8 10.45 8 11C8 11.55 7.55 12 7 12Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default APIIcon;
